















import { Vue, Component, Prop } from 'vue-property-decorator';
import SkillTypes from '@/views/drd-2.0/skill/skill-types.json';
import ReadDrdCaptionInterface from './read-drd-caption.interface';
import ReadDrdCaptionItem from './read-drd-caption-item.component.vue';

@Component({
  components: { ReadDrdCaptionItem },
})
export default class ReadDrdCaption extends Vue {
  @Prop({ type: String, required: true })
  title !: string;

  @Prop({ type: Boolean, default: false })
  flat !: boolean

  @Prop({ type: Boolean, default: false })
  dense !: boolean

  @Prop({ type: String, required: true })
  skillType!: string;

  get captions(): ReadDrdCaptionInterface[] {
    const skillTypeObject = SkillTypes.find(type => type.value === this.skillType);
    if (!this.skillType || !skillTypeObject) return [];
    if (this.skillType === 'KNOWLEDGE') {
      return [
        { title: 'R - Recomendado', description: 'Item recomendado para o nível de carreira' },
        { title: 'E - Esperado', description: 'Item esperado/obrigatório para o nível de carreira' },
      ];
    }
    return SkillTypes
      .filter(type => type.value === this.skillType)[0]
      .options.filter(option => option.isSelected)
      .map(option => ({
        title: `${option.value - skillTypeObject.decrementValue!!} (${option.name})`,
        description: option.details,
      }));
  }
}
